/* ClientCards auto-generated by npm run generator */
import { makeStyles, Theme, Typography } from "@material-ui/core"
import { Client, Mood, toPrettyPhoneNum } from "@qlarity/common"
import { observer } from "mobx-react"
import React from "react"
import Store from "store/Store"
import { defaultTheme } from "style"
import RedeemPoints from "./dialogs/RedeemPoints"

interface ClientCardsProps {
    client: Client
}

const useStyles = makeStyles((theme: Theme) => ({
    clientCardsMolecule: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, 230px)",
        gridAutoRows: "minmax(192px, auto)",
        textAlign: "center",
        gridGap: theme.spacing(4),
    },
    card: {
        borderRadius: theme.spacing(3),
        backgroundColor: theme.palette.secondary.main,
        display: "grid",
        gridTemplateRows: `auto 1fr ${theme.spacing(5)}px`,
        alignItems: "center",
        padding: theme.spacing(2),
        "& .MuiTypography-overline": {
            color: theme.palette.text.secondary,
        },
    },
}))

const ClientCards: React.FC<ClientCardsProps> = ({ client }) => {
    const classes = useStyles()

    const getCurrentModNumber = () => {
        return Store.clientStore.findCurrentModule(client)?.name.split(".")[0]
    }
    const getCurrentModName = () => Store.clientStore.findCurrentModule(client)?.name.split(".")[1].trim()

    return (
        <>
            <div className={classes.clientCardsMolecule}>
                <div className={classes.card}>
                    <Typography variant="h6">Total Points</Typography>
                    <Typography variant="h1">{client.points ?? 0}</Typography>
                    <RedeemPoints client={client} />
                </div>
                <div className={classes.card}>
                    <Typography variant="h6">Last Mood</Typography>
                    <Typography variant="h1">
                        {client.checkins && <Mood name={client.checkins?.slice(-1)[0].moodName} fill={defaultTheme.palette.text.primary} height={65} />}
                    </Typography>
                    <Typography variant="overline">{client.checkins?.slice(-1)[0].moodName}</Typography>
                </div>
                <div className={classes.card}>
                    <Typography variant="h6">Current Module</Typography>
                    <Typography variant="h1">{getCurrentModNumber()}</Typography>
                    <Typography variant="overline">{getCurrentModName()}</Typography>
                </div>
                <div className={classes.card}>
                    <Typography variant="h6">Last Login</Typography>
                    <Typography variant="body1">
                        {Store.clientStore.findLastActivity(client)?.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}
                        <br />
                        {Store.clientStore.findLastActivity(client)?.toLocaleDateString()}
                    </Typography>
                    <Typography variant="overline">Date</Typography>
                </div>
                <div className={classes.card}>
                    <Typography variant="h6">Phone Number</Typography>
                    <Typography>{toPrettyPhoneNum(client.phoneNumber)}</Typography>
                    <Typography variant="overline">Case ID</Typography>
                    <Typography>{Store.clientStore.getShortId(client)}</Typography>
                </div>
            </div>
        </>
    )
}

export default observer(ClientCards)
